var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.861 15.707H1.577c-.517 0-.701-.186-.701-.706v-4.008c0-.514.195-.71.705-.71h3.28v-2.91c.001-1.313.235-2.57.903-3.72.683-1.179 1.677-1.986 2.95-2.453.817-.299 1.664-.418 2.53-.419 1.083 0 2.166 0 3.25.003.465 0 .672.206.673.675.002 1.257.002 2.514 0 3.77 0 .474-.199.664-.675.67-.888.01-1.777.003-2.664.04-.896 0-1.367.437-1.367 1.364-.021.98-.009 1.963-.009 2.98h3.825c.542 0 .727.185.727.73 0 1.328 0 2.657-.002 3.986 0 .537-.174.708-.718.708H10.44v10.755c0 .574-.18.757-.746.757H5.557c-.5 0-.695-.195-.695-.695V15.707z"
  })));
}

export default SvgFacebookSecond;